import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import Col from 'react-bootstrap/Col'
import MultiSelect from '~/components/multi_select'
import Select from '~/components/select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import { awsAccountsChartOptionPath, awsRegionsChartOptionPath } from '~/routes'
import { awsChargeTypes } from '~/utils/aws'

export default function AWSRDSDashboardReservationsFilters({ organizationId: orgId, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)

  const accountsUrl = useMemo(() => awsAccountsChartOptionPath(orgId), [orgId])
  const regionsUrl = useMemo(() => awsRegionsChartOptionPath(orgId), [orgId])

  return (
    <DashboardFilters onApply={onApply} onReset={onReset}>
      <Col>
        <MultiSelect
          label={t`Account`}
          name='awsAccountIds'
          onChange={onChange}
          url={accountsUrl}
          selected={params.awsAccountIds}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Region`}
          name='awsRegions'
          onChange={onChange}
          url={regionsUrl}
          params={params}
          selected={params.awsRegions}
        />
      </Col>
      <Col>
        <Select
          label={t`Charge type`}
          name='awsChargeType'
          onChange={onChange}
          options={awsChargeTypes()}
          defaultOption='unblended'
        />
      </Col>
    </DashboardFilters>
  )
}
